<template>
  <div>
    <el-form size="small">
      <el-row :gutter="15">
        <el-col :span="12">
          <DateForm ref="dateForm" />
        </el-col>
        <el-col :span="12">
          <el-form-item label="Carrier">
            <CarrierAutoComplete
              ref="carrierList"
              v-model="carrier"
              placeholder="All Carrier"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col>
        <el-button
          type="primary"
          size="small"
          class="float-right"
          @click.native="downloadCSV()"
        >
          Generate Report
        </el-button>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Carrier Invoice Report"
      :is-show.sync="isShowPreview"
      :configuration="configuration"
    />
  </div>
</template>

<script>
import DateForm from '@/components/Application/Reports/DateForm'
import CarrierAutoComplete from '@/components/Application/Reports/CarrierAutoComplete'
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    DateForm,
    CarrierAutoComplete,
    Preview
  },
  data () {
    return {
      breadcrumb: {
        name: 'Carrier Invoice Report',
        route: { name: 'reports-invoice-carrier' }
      },
      carrier: {},
      form: {
        carrierId: null,
        dateFrom: null,
        dateTo: null,
        internalConsOnly: false,
        showMarginData: false
      },
      isShowPreview: false,
      configuration: null
    }
  },
  methods: {
    setDate (date) {
      this.form.dateFrom = this.$moment(date[0]).format('YYYY-MM-DD HH:mm:ss')
      this.form.dateTo = this.$moment(date[1]).format('YYYY-MM-DD HH:mm:ss')
    },
    downloadCSV () {
      this.$refs.dateForm.$refs.form.validate(async valid => {
        if (valid) {
          this.setDate(this.$refs.dateForm.form.value)
          if (this.$refs.carrierList.input) {
            this.form.carrierId = this.$refs.carrierList.input
          }

          this.configuration = {
            report: 'InvoiceImportReport',
            params: this.form
          }
          this.isShowPreview = true
        }
      })
    }

  }
}
</script>

<style>

</style>
